module.exports = __webpack_public_path__ + "static/media/zeya_drawing_05.36d043ec.png";